<template>
  <span>
    <div
      class="background-wallpaper"
      style="background-image: url(https://wallpapercave.com/wp/wp6896343.jpg)"
    ></div>
    <section class="">
      <div class="container content">
        <div style="clear: both; height: 100px"></div>
        <div class="column text-center">
          <h1>DEMO &amp; PODCAST SUBMISSION</h1>
        </div>
        <div class="column c6 push-center">
          <p class="text-center">
            If you want to join the community, send us your art. Wether it's by
            sending us your latest mix, production or artworks. We're always
            looking for new talented individuals!
          </p>
        </div>
      </div>
    </section>
    <FormulateForm class="" @submit="submitForm">
      <div class="container content semform">
        <div class="semantic-form">
          <div class="ui form">
            <div class="field">
              <label>POD CAST / DEMO</label>
              <FormulateInput
                type="select"
                validation="required"
                validation-name="Submission Type"
                name="type"
                v-model="form.type"
                class="form-100"
                :options="[
                  { value: null, label: 'SELECT YOUR SUBMISSION TYPE' },
                  { value: 'PODCAST', label: 'PODCAST' },
                  { value: 'DEMO SUBMISSION', label: 'DEMO SUBMISSION' },
                ]"
              />
            </div>
            <div class="field">
              <label>Artist Name</label>
              <FormulateInput
                type="text"
                name="artistname"
                v-model="form.artistname"
                validation="required"
                class="form-100"
              />
            </div>
            <div class="field">
              <label>Email Address</label>
              <FormulateInput
                type="email"
                name="email"
                v-model="form.email"
                validation="required"
                class="form-100"
              />
            </div>
            <div class="field">
              <label>Bio</label>
              <FormulateInput
                type="textarea"
                name="bio"
                v-model="form.bio"
                validation="required"
                class="form-100"
                rows="10"
              />
            </div>
            <div class="field">
              <label>Tracklist / Release Details</label>
              <FormulateInput
                type="textarea"
                name="tracklist"
                v-model="form.tracklist"
                validation="required"
                class="form-100"
                rows="10"
              />
            </div>
          </div>
          <div class="field">
            <label>Soundcloud Link - Must Be Private</label>
            <FormulateInput
              type="text"
              name="link"
              v-model="form.link"
              validation="required"
              class="form-100"
            />
          </div>
          <div class="field">
            <FormulateInput
              type="checkbox"
              validation="required"
              label=" I AGREE TO THE TERMS &amp; CONDITIONS OF THIS WEBSITE"
            />
          </div>
          <div class="field">
            <div class="button-icon">
              <input class="submit" type="submit" :disabled='isDisabled'>
              <i class="far fa-envelope"></i>
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both; height: 100px"></div>
    </FormulateForm>
  </span>
</template>

<script>
import axios from 'axios'
import emailjs from 'emailjs-com'

export default {
  title: 'Patronus Records - Demo / Podcast Submission',
  name: 'submission',
  data () {
    return {
      isDisabled: false,
      form: {
        type: [],
        artistname: null,
        email: null,
        bio: null,
        tracklist: null,
        link: null
      }
    }
  },
  methods: {
    submitForm () {
      this.isDisabled = true
      this.form.type = this.form.type.toString()
      axios
        .post('https://admin.patronusrecords.com/submissions', this.form)
        .then((res) => {
          console.log('success')
          emailjs
            .send(
              'service_omqin1f',
              'template_p0x6bz5',
              {
                from_name: this.form.artistname,
                email: this.form.email,
                type: this.form.type,
                message: this.form.link + '\n\n' + this.form.tracklist
              },
              'user_rDkovUZ6FIPW5500KTKAa'
            )
            .then(
              (result) => {
                console.log('SUCCESS!', result.text)
                this.$router.push('thankyou')
              },
              (error) => {
                console.log('FAILED...', error.text)
              }
            )
        })
        .catch((error) => {
          console.log('failed', error)
          console.log('failed', error)
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        })
        .finally(() => {
          console.log('what the fuck is finally?')
        })
    }
  }
}
</script>
<style>
.artwork {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: contain;
}
.field {
  text-align: center;
  width: 100%;
  margin: auto;
}
label {
  width: 100%;
  display: block;
  text-transform: uppercase;
  padding-bottom: 15px;
  margin-top: 20px;
}
input,
select,
textarea {
  width: 100%;
  margin-bottom: 15px;
  padding: 15px;
  background-color: #080c1780;
  border: 0px;
  border-radius: 5px;
  text-align: center;
  font-size: 18px;
}
.submit {
  background-color: var(--primary);
  color: white;
  text-transform: uppercase;
  border: none;
}
.semform {
  max-width: 500px;
  width: 100%;
}
.button-icon {
  position: relative;
}
.button-icon i {
  float: right;
  position: absolute;
  top: 0;
  right: 15px;
  font-size: 25px;
  top: 12px;
}
.form-section .formulate-input-label {
  clear: both;
  display: block;
  width: 100%;
  text-transform: uppercase;
  padding-top: 20px;
  margin-bottom: 10px;
}
.form-section input,
.form-section textarea,
.form-section select {
  padding: 15px;
  background-color: #080c1780;
  border: none;
  width: 100%;
  color: white;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 100;
}
.form-section button {
  width: 100%;
  max-width: 300px;
  cursor: pointer;
}
.form-section .formulate-input-error {
  color: red;
  padding: 10px;
}
.form-50 {
  width: 50%;
  padding: 10px;
  float: left;
}
.form-100 {
  width: 100%;
  padding: 10px;
  float: left;
}
h2.FormTitle {
  background-color: var(--primary);
  padding: 15px;
  border-radius: 11px;
  text-align: left;
  padding-left: 30px;
  clear: both;
  margin-top: 20px;
}
h3.FormTitle {
  padding: 15px;
  border-radius: 11px;
  text-align: left;
  clear: both;
  margin-left: -10px;
  margin-top: 20px;
}
.form-section {
  clear: both;
  margin-top: 20px;
  margin-bottom: 10px;
  overflow: auto;
}

.optionbox input ~ label {
  border: 1px solid var(--secondary);
  display: block;
  width: 20px;
  height: 20px;
  float: left;
  border-radius: 100%;
}
.optionbox input:checked ~ label {
  border: 1px solid green;
  display: block;
}

.optionbox [type="checkbox"],
[type="radio"] {
  display: none;
}
.optionbox .formulate-input-group-item {
  width: 25%;
  padding: 4px;
  float: left;
}
.optionbox .formulate-input-label {
  text-align: left;
  float: left;
  margin-left: 8px;
}
.optionbox input:checked ~ label::after {
  content: " ";
  display: block;
  position: relative;
  background-color: green;
  border-radius: 10px;
  height: 10px;
  width: 10px;
  margin-left: 4px;
  margin-top: 4px;
}
@media only screen and (max-width: 660px) {
  .form-50 {
    width: 100%;
  }
  .form-50 button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/submission.vue